import { jsonPost, jsonGet, jsonPut, jsonDelete } from "../api.js";

export const getToolList = async () => jsonGet("tools");
export const getTool = async (toolId) => jsonGet(`tools/${toolId}`);
export const createTool = async (toolData) => jsonPost("tools", toolData);
export const updateTool = async (toolId, toolData) =>
  jsonPut(`tools/${toolId}`, toolData);
export const deleteTool = async (toolId) => jsonDelete(`tools/${toolId}`);
export const getToolUsage = async (toolId) => jsonGet(`tools/${toolId}/usage`);
